import OperationRunner from './OperationRunner';
import { GetListOperation, GetOperation, PostOperation, PatchOperation, DeleteOperation } from './operations'; // eslint-disable-line

export default class BaseApi {
  getIri(id) {
    return id
      ? `/api/${this.constructor.entityName}/${id}`
      : `/api/${this.constructor.entityName}`;
  }

  // eslint-disable-next-line class-methods-use-this
  execute(operation, withPreloader = false) {
    const runner = new OperationRunner(operation, withPreloader);
    return runner.run();
  }

  fetchItem(id, params = {}, withPreloader = false) {
    const iri = this.getIri(id);
    const operation = new GetOperation(iri, params);
    return this.execute(operation, withPreloader);
  }

  fetchList(params = {}, withPreloader = false) {
    const iri = this.getIri();
    const operation = new GetListOperation(iri, params);
    return this.execute(operation, withPreloader);
  }

  create(params = {}, withPreloader = false) {
    const iri = this.getIri();
    const operation = new PostOperation(iri, params);
    return this.execute(operation, withPreloader);
  }

  update(id, params = {}, withPreloader = false) {
    const iri = this.getIri(id);
    const operation = new PatchOperation(iri, params);
    return this.execute(operation, withPreloader);
  }

  delete(id, withPreloader = false) {
    const iri = this.getIri(id);
    const operation = new DeleteOperation(iri);
    return this.execute(operation, withPreloader);
  }
}
